import * as THREE from "three";
import { AnimationUtils } from "three";
import hash from "object-hash";

class AnimationManager {
  loadingManager;

  constructor(world) {
    this.world = world;

    this.mixers = {};
    this.animationClips = {};
    this.animationActions = {};
  }

  getAnimationClip(rootObject, definition) {
    if (!definition || !rootObject) {
      return undefined;
    }

    const animationId = hash(definition);

    if (!this.animationClips[animationId]) {
      const { name = "Take 001", startFrame, endFrame, fps } = definition;

      const fullAnimation = rootObject.animations.find(
        (item) => item.name === name
      );
      
      this.animationClips[animationId] =
        isNaN(startFrame) || isNaN(endFrame) || isNaN(fps)
          ? fullAnimation
          : AnimationUtils.subclip(
              fullAnimation,
              animationId,
              startFrame,
              endFrame,
              fps
            );
    }
    
    return this.animationClips[animationId];
  }

  getAnimationMixer(rootObject, id = "defaultMixer") {
    if (!this.mixers[id]) {
      this.mixers[id] = new THREE.AnimationMixer(rootObject);
    }
    return this.mixers[id];
  }

  getAnimationAction(rootObject, animation) {
    const clip = this.getAnimationClip(rootObject, animation.clip);
    const mixerId = animation.mixer || clip.uuid;
    const mixer = this.getAnimationMixer(rootObject, mixerId);

    const actionId = hash({
      clipUuid: clip.uuid,
      mixerId,
    });

    if (!this.animationActions[actionId]) {
      this.animationActions[actionId] = mixer.clipAction(clip);
    }
    return this.animationActions[actionId];
  }

  update(delta) {
    for (const key in this.mixers) {
      this.mixers[key].update(delta);
    }
    for (const key in this.animationActions) {
      if (this.animationActions[key].isRunning()) {
        this.world.change$.next();
        break;
      }
    }
  }
}

export default AnimationManager;
